module.exports = __webpack_public_path__ + "static/media/coalesse-4.ef374217.jpg";